"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Card = require("./Card");
var _getLegacySpacingModeCss = _interopRequireDefault(require("./internal/getLegacySpacingModeCss"));
var _styles = _interopRequireDefault(require("../styles"));
var _globalSpacing = require("./../globalSpacing");
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "spacingOptions"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var borderRadiusStyles = {
  borderBottomLeftRadius: _tokens.borderRadiusMedium,
  borderBottomRightRadius: _tokens.borderRadiusMedium
};
var styles = function styles(theme) {
  var _lastChild, _responsive;
  return {
    // MUI classes
    root: {
      '&:last-child': {
        padding: 0
      }
    },
    // Custom Path classes
    standard: {
      padding: _tokens.spacing40 + " " + _tokens.spacing60,
      '&:last-child': {
        padding: _tokens.spacing40 + " " + _tokens.spacing60
      }
    },
    dense: {
      padding: "0.75rem " + _tokens.spacing50,
      '&:last-child': {
        padding: "0.75rem " + _tokens.spacing50
      }
    },
    none: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },
    responsive: (_responsive = {}, _responsive[theme.breakpoints.only('xs')] = {
      padding: _tokens.spacing30 + " " + _tokens.spacing40
    }, _responsive['&:last-child'] = (_lastChild = {}, _lastChild[theme.breakpoints.only('xs')] = {
      padding: _tokens.spacing30 + " " + _tokens.spacing40
    }, _lastChild), _responsive),
    negateSpacing: (0, _extends2.default)({}, borderRadiusStyles, {
      '& > *:last-child': (0, _extends2.default)({}, borderRadiusStyles)
    })
  };
};

/**
 * CardContent component for displaying content on a Card component
 */
var CardContent = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _cn;
  var classes = props.classes,
    spacingOptions = props.spacingOptions,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var negateSpacingAll = (0, _get.default)(spacingOptions, 'negateSpacingAll');
  var negateSpacingStyles = (0, _globalSpacing.useSpacing)({
    spacing: {
      style: {
        margin: "0 -" + _tokens.spacing40 + " -" + _tokens.spacing40,
        display: 'block'
      },
      lg: {
        style: {
          margin: "0 -" + _tokens.spacing50 + " -" + _tokens.spacing50
        }
      }
    }
  });
  var classesOverrides = negateSpacingAll ? negateSpacingStyles : (0, _getLegacySpacingModeCss.default)((0, _react.useContext)(_Card.CardContext), classes); //eslint-disable-line react-hooks/rules-of-hooks

  var classOverrides = {
    root: (0, _classnames.default)(classes.root, classesOverrides, (_cn = {}, _cn[classes.negateSpacing] = negateSpacingAll, _cn))
  };
  return /*#__PURE__*/_react.default.createElement(_CardContent.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});
CardContent.muiName = 'CardContent';
CardContent.displayName = 'CardContent';
CardContent.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes.default.elementType,
  /**
   * Adds negative margins on all dimensions
   *
   * `negateSpacingAll` (bool): **true** | false
   *
   *  * If set to `true`, adds negative margins on all dimensions.
   *  * Helpful when you want to remove the outer padding for card content
   */
  spacingOptions: _propTypes.default.shape({
    negateSpacingAll: _propTypes.default.bool
  }),
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};

// If default props are needed, they must be set here
CardContent.defaultProps = {
  component: 'div'
};
var _default = exports.default = (0, _styles.default)(styles)(CardContent);